export { getCommands, getCommandCategories } from './utils/MailModuleHotKeys';
//# sourceMappingURL=index.js.map